import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { BotStepView } from "./BotStepView";
import { BotStepViewStore } from "../../store/BotStepViewStore";
import { useStore } from "../../../../hooks";

export const BotStepViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/botStep/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new BotStepViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <BotStepView botStepViewStore={store} />
      </PageLayout>
    </div>
  );
});
